import * as d3 from 'd3'

export const IMPLIED_RATING_DOMAIN = ['A', 'AA', 'B', 'BB', 'BBB']

export const getChartColorRange = keyLength => {
  return [
    '#1A8DD2',
    '#9DCBFD',
    '#3393f3',
    '#19CEFF',
    '#064C9B',
    '#156ed3',
  ].splice(0, keyLength)
}

export const getCircleColor = impliedRating => {
  const d3ScaleSize = d3
    .scaleOrdinal()
    .domain(IMPLIED_RATING_DOMAIN)
    .range(['#19ceff', '#a0d1ef', '#70aae7', '#2781d9', '#066b7f'])

  return d3ScaleSize(impliedRating)
}

export const FUNDAMENTAL_TOGGLE_COLOR = {
  COMPANY_HISTORY: '#3393F3',
  POD_COMPARE1: '#162473',
  POD_COMPARE2: '#9d0303',
  POD_COMPARE3: '#d7b804',
  PEER_GROUP: '#34D8E2',
  EQUITY_PRICE: '#066b7f',
  ASSET_VOLATILITY: '#1B3963',
  LEVERAGE: '#8B0000',
  MARKET_VALUE_OF_ASSET: '#FF834E',
  UNRECOGNISED_RISK_STATUS: '#1B3963',
  RISK_EVENTS: '#1B3963',
}

export const TOGGLE_INDEX = {
  COMPANY_HISTORY: 1,
  PEER_GROUP: 2,
  EQUITY_PRICE: 3,
  ASSET_VOLATILITY: 4,
  LEVERAGE: 5,
  MARKET_VALUE_OF_ASSET: 6,
  UNRECOGNISED_RISK_STATUS: 7,
  RISK_EVENTS: 8,
}

export const getDotSize = impliedRating => {
  const d3ScaleSize = d3
    .scaleOrdinal()
    .domain(IMPLIED_RATING_DOMAIN)
    .range([3, 4, 5, 5.5, 6])

  return d3ScaleSize(impliedRating)
}

export const countYAxisTick = data => {
  return (
    d3.max(data, d => d.date.getFullYear()) -
    d3.min(data, d => d.date.getFullYear()) +
    1
  )
}

export const getImpliedRatingChangeColor = impliedRatingChange => {
  return impliedRatingChange === 2 ? '#758396' : '#1B3963'
}

export const getTrendColor = rating_trend => {
  return TREND_COLOR[rating_trend]
}

export const TREND_COLOR = {
  Positive: '#32AE6C',
  Stable: '#758396',
  Negative: '#DE3131',
  Default: '#1B3963',
}

export const getTrendSymbol = rating_trend => {
  return TREND_SYMBOL[rating_trend]
}

export const TREND_SYMBOL = {
  Positive: '+',
  Stable: '',
  Negative: '-',
  Default: '',
}

export const formatPercentageNumber = number => {
  return !isNaN(number) ? Number(number * 100).toFixed(2) * 1 : number
}

// need to update logic
// show scan chart if one of stack area chart is not empty
// and less than 2 scan charts empty
export const showingScanChart = charts => {
  const stackAreaChecked =
    charts.filter(
      c => c.type === 'StackedAreaChart' && c.data && c.data.length > 1,
    ).length > 1

  const scanChartChecked =
    charts.filter(c => c.type === 'LineChart' && c.data && c.data.length > 1)
      .length >= 4

  return stackAreaChecked && scanChartChecked
}

export const RISK_STATUS_CONST = ['Neutral', 'Low', 'Medium', 'High']
export const RISK_STATUS_COLOR_SCALE = {
  High: '#800202',
  Medium: '#D10000',
  Low: '#FF5C5C',
  Neutral: '#BBC0C7',
}
export const riskStatusData = [
  { id: 'High', value: 'High', isChecked: false, type: 'equityRisk' },
  { id: 'Medium', value: 'Medium', isChecked: false, type: 'equityRisk' },
  { id: 'Low', value: 'Low', isChecked: false, type: 'equityRisk' },
  { id: 'Neutral', value: 'Neutral', isChecked: false, type: 'equityRisk' },
]
export const creditRiskStatusData = [
  { id: 'HighCreditRisk', value: 'High', isChecked: false, type: 'creditRisk' },
  {
    id: 'MediumCreditRisk',
    value: 'Medium',
    isChecked: false,
    type: 'creditRisk',
  },
  { id: 'LowCreditRisk', value: 'Low', isChecked: false, type: 'creditRisk' },
  {
    id: 'NeutralCreditRisk',
    value: 'Neutral',
    isChecked: false,
    type: 'creditRisk',
  },
]

export const mappingMarbleData = (item, getValue) => {
  if (item === 'Total') {
    getValue({ name: 'total' })
  } else {
    getValue({ name: item })
  }
}

export const getCompanyStatus = status => {
  switch (status) {
    case 'Medium':
      return 'Elevated Risk 2'
    case 'Neutral':
      return 'Neutral Risk'
    case 'Low':
      return 'Elevated Risk 1'
    case 'High':
      return 'Elevated Risk 3'
    default:
      return 'Risk Status'
  }
}

export const filterByRiskType = (item, riskType, level) => {
  return riskType === RISK_TYPE.EQUITY
    ? item.status === level
    : item.credit_status === level
}

export const getCompanyStatusWithType = (status, type) => {
  switch (status) {
    case 'Medium':
      return `Elevated 2 ${type} Risk`
    case 'Neutral':
      return `Neutral ${type} Risk`
    case 'Low':
      return `Elevated 1 ${type} Risk`
    case 'High':
      return `Elevated 3 ${type} Risk`
    default:
      return 'Risk Status'
  }
}

export const RISK_TYPE = {
  EQUITY: 'EQUITY',
  CREDIT: 'CREDIT',
}

export const commonMapFilter = list => {
  return list.map(i => {
    let a =
      i.status === 'High'
        ? 1
        : i.status === 'Medium'
        ? 2
        : i.status === 'Low'
        ? 3
        : 4
    let b =
      i.prev_status === 'High'
        ? 1
        : i.prev_status === 'Medium'
        ? 2
        : i.prev_status === 'Low'
        ? 3
        : 4
    let a1 =
      i.credit_status === 'High'
        ? 1
        : i.credit_status === 'Medium'
        ? 2
        : i.credit_status === 'Low'
        ? 3
        : 4
    let b1 =
      i.prev_credit_status === 'High'
        ? 1
        : i.prev_credit_status === 'Medium'
        ? 2
        : i.prev_credit_status === 'Low'
        ? 3
        : 4
    return {
      ...i,
      sortByEquityRisk: `${a}${b}`,
      sortByCreditRisk: `${a1}${b1}`,
    }
  })
}
